export default "__VITE_ASSET__dd70b15f__"